// Reserve the actual mobile bar height, including its safe-area padding.
class FooterBottomClearance extends HTMLElement {
  connectedCallback() {
    this.mobile = matchMedia('(max-width: 749px)');
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    };
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.mutationObserver = new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList' ||
        this.bars.some((bar) => record.target === bar || record.target.contains(bar)))) {
        this.schedule();
      }
    });
    this.bars = [];
    this.mutationObserver.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'data-stuck', 'data-cart-open', 'data-variant-available'],
    });
    this.mobile.addEventListener('change', this.schedule);
    window.addEventListener('resize', this.schedule);
    window.visualViewport?.addEventListener('resize', this.schedule);
    document.addEventListener('transitionend', this.schedule);
    this.update();
  }

  update() {
    const bars = [...document.querySelectorAll('.facets-toggle--bottom-bar, .sticky-add-to-cart__bar')];
    for (const bar of this.bars) {
      if (!bars.includes(bar)) this.resizeObserver.unobserve(bar);
    }
    for (const bar of bars) {
      if (!this.bars.includes(bar)) this.resizeObserver.observe(bar);
    }
    this.bars = bars;
    let height = 0;
    if (this.mobile.matches) {
      for (const bar of bars) {
        const style = getComputedStyle(bar);
        if (style.position !== 'fixed' || style.display === 'none' || !bar.getClientRects().length) continue;
        const sticky = bar.closest('sticky-add-to-cart');
        if (sticky) {
          if (bar.dataset.stuck !== 'true' || sticky.dataset.cartOpen === 'true' ||
            sticky.dataset.variantAvailable !== 'true') continue;
        } else if (style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
        // Use the untransformed height so show/hide animations do not change the spacer.
        height = Math.max(height, bar.getBoundingClientRect().height + Math.max(0, parseFloat(style.bottom) || 0));
      }
    }
    const value = `${Math.ceil(height)}px`;
    if (this.style.height !== value) this.style.height = value;
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.resizeObserver.disconnect();
    this.mutationObserver.disconnect();
    this.mobile.removeEventListener('change', this.schedule);
    window.removeEventListener('resize', this.schedule);
    window.visualViewport?.removeEventListener('resize', this.schedule);
    document.removeEventListener('transitionend', this.schedule);
  }
}

if (!customElements.get('footer-bottom-clearance')) {
  customElements.define('footer-bottom-clearance', FooterBottomClearance);
}
